// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

export const environment = {
  production: false,
  // apiBaseUrl: 'http://192.168.1.101:8082/imobility',  // Local Host 
  // apiBaseUrl: 'https://ssc.mapembedded.com/nagarsetu',  // Production Host vultr
  apiBaseUrl: 'https://ssc.mapembedded.com/nagarsetu',

  // apiBaseUrl: 'https://imobility.in/imobility',  // Production Host ctrls
  // apiBaseUrl: 'http://imobility.in:8080/imobility',  // Production Host 

  // apiBaseUrl: 'http://192.168.17.132:8081/imobility',
  // apiBaseUrl: 'http://192.168.1.39:8082/imobility', // Local Host
  //  apiBaseUrl: 'http://192.168.1.6:8082/imobility', // Local Host //jay system ip
  
};
            
/* 
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
